import type {SelectItemProps} from '@smart/react-components';
import React, {useMemo} from 'react';
import type {Maybe} from '../../graphql';
import type {availableCountries} from '../common/types';
import {phoneMap} from '../common/types';
import {useSchemas} from '../hooks/user-schemas';
import Fields from './easy-form/fields';

interface IProps {
  tag: string;
  mkt?: (typeof availableCountries)[number];
  required?: boolean;
  props: {className: string | undefined; disabled?: boolean};
  label?: Maybe<string>;
}

export default function PhoneCodeSelect({
  tag,
  mkt,
  required,
  props,
  label,
}: IProps): JSX.Element {
  // * Needed for selected market phone code prefill *
  let initialMktCode = ``;
  if (mkt !== undefined && mkt in phoneMap) {
    initialMktCode = phoneMap[mkt];
  }

  const codeSelect = useMemo<SelectItemProps[]>(
    () => [
      {value: ``, label: ``},
      ...Object.entries(phoneMap).map((phoneCode) => ({
        value: `${phoneCode[1]}`,
        label: `${phoneCode[0]}` + ` ${phoneCode[1]}`,
      })),
    ],

    [PhoneCodeSelect, mkt],
  );
  const generalSchemas = useSchemas();
  const schema = useMemo(() => {
    const {phoneCode} = generalSchemas;
    return phoneCode(required);
  }, [generalSchemas, required]);

  return (
    <Fields.Select
      label={label}
      initial={initialMktCode}
      tag={tag}
      options={codeSelect}
      required={required}
      schema={schema}
      props={props}
    />
  );
}
